export default {
  translation: {
    common: {
      enter: 'Vào',
      delete: 'Xóa',
      deleteModalTitle: 'Bạn có chắc chắn muốn xóa không?',
      permissionTitle: 'Thiết lập quyền người dùng',
      ok: 'Đồng ý',
      cancel: 'Hủy',
      total: 'Tổng',
      rename: 'Đổi tên',
      name: 'Tên',
      save: 'Lưu',
      namePlaceholder: 'Vui lòng nhập tên',
      next: 'Tiếp theo',
      create: 'Tạo',
      edit: 'Chỉnh sửa',
      upload: 'Tải lên',
      english: 'Tiếng Anh',
      portugueseBr: 'Tiếng Bồ Đào Nha (Brazil)',
      chinese: 'Tiếng Trung giản thể',
      traditionalChinese: 'Tiếng Trung phồn thể',
      language: 'Ngôn ngữ',
      languageMessage: 'Vui lòng nhập ngôn ngữ',
      languagePlaceholder: 'Vui lòng chọn ngôn ngữ',
      copy: 'Sao chép',
      copied: 'Sao chép thành công',
      comingSoon: 'Sắp ra mắt',
      download: 'Tải xuống',
      close: 'Đóng',
      preview: 'Xem trước',
      move: 'Di chuyển',
      warn: 'Nhắc nhở',
      action: 'Thao tác',
      s: 'giây',
      pleaseSelect: 'Vui lòng chọn',
      pleaseInput: 'Vui lòng nhập',
      submit: 'Gửi',
      embedIntoSite: 'Nhúng vào website',
      previousPage: 'Trang trước',
      nextPage: 'Trang sau',
      copyFailed: 'Sao chép thất bại, vui lòng sao chép thủ công',
      imageLoading: 'Đang tải hình ảnh...',
      viewFullImage: 'Xem hình ảnh đầy đủ',
      backToChat: 'Quay lại trò chuyện',
      saveSuccess: 'Lưu thành công',
      saveFailed: 'Lưu thất bại',
      cannotDeleteLastTwo:
        'Không thể xóa hai cuộc trò chuyện cuối cùng',
    },
    message: {
      email_code_sent: 'Mã xác minh email đã được gửi',
      permissionUpdated: 'Cập nhật quyền thành công',
      registered: 'Đăng ký thành công',
      logout: 'Đăng xuất thành công',
      logoutFailed: 'Đăng xuất thất bại',
      logged: 'Đăng nhập thành công',
      pleaseSelectChunk: 'Vui lòng chọn chunk phân tích',
      modified: 'Cập nhật thành công',
      created: 'Tạo thành công',
      deleted: 'Xóa thành công',
      renamed: 'Đổi tên thành công',
      operated: 'Thao tác thành công',
      updated: 'Cập nhật thành công',
      uploaded: 'Tải lên thành công',
      failed: 'Thất bại',
      200: 'Máy chủ đã trả về dữ liệu yêu cầu thành công',
      201: 'Tạo mới hoặc sửa đổi dữ liệu thành công',
      202: 'Yêu cầu đã được đưa vào hàng đợi xử lý (tác vụ bất đồng bộ)',
      204: 'Xóa dữ liệu thành công',
      400: 'Yêu cầu gửi đi có lỗi, máy chủ không thực hiện tạo mới hoặc sửa đổi dữ liệu',
      401: 'Vui lòng đăng nhập lại',
      403: 'Người dùng đã được ủy quyền, nhưng bị cấm truy cập',
      404: 'Yêu cầu gửi đến bản ghi không tồn tại, máy chủ không thực hiện thao tác',
      406: 'Định dạng yêu cầu không hợp lệ',
      410: 'Tài nguyên yêu cầu đã bị xóa vĩnh viễn và sẽ không còn tồn tại',
      413: 'Tổng dung lượng tệp tải lên quá lớn',
      422: 'Đã xảy ra lỗi xác minh khi tạo đối tượng',
      500: 'Máy chủ gặp lỗi, vui lòng kiểm tra máy chủ',
      502: 'Lỗi gateway',
      503: 'Dịch vụ không khả dụng, máy chủ quá tải hoặc đang bảo trì',
      504: 'Gateway timeout',
      requestError: 'Lỗi yêu cầu',
      networkAnomalyDescription: 'Mạng của bạn gặp sự cố, không thể kết nối máy chủ',
      networkAnomaly: 'Lỗi mạng',
      hint: 'Gợi ý',
      verifyCodeError: 'Mã xác minh không chính xác',
      userLocked: 'Người dùng đã bị khóa',
    },
    login: {
      login: 'Đăng nhập',
      signUp: 'Đăng ký',
      loginDescription: 'Tùy chỉnh dịch vụ dành riêng cho bạn!',
      registerDescription: 'Rất mong được bạn tham gia!',
      emailLabel: 'Email',
      emailPlaceholder: 'Email',
      passwordLabel: 'Mật khẩu',
      passwordPlaceholder: 'Mật khẩu',
      rememberMe: 'Ghi nhớ mật khẩu',
      signInTip: 'Chưa có tài khoản?',
      signUpTip: 'Đã có tài khoản?',
      nicknameLabel: 'Tên người dùng',
      nicknamePlaceholder: 'Tên người dùng',
      corporateLabel: 'Công ty/Tổ chức',
      corporatePlaceholder: 'Tên công ty/tổ chức',
      phoneLabel: 'Số điện thoại',
      phonePlaceholder: 'Vui lòng nhập số điện thoại',
      emailVerifyCodeLabel: 'Mã xác minh email',
      emailVerifyCodePlaceholder: 'Mã xác minh email',
      emailVerifyCodeSent:
        'Mã xác minh đã được gửi đến email của bạn, vui lòng kiểm tra.',
      emailFormatError: 'Định dạng email không hợp lệ',
      phoneVerifyCodeLabel: 'Mã xác minh',
      phoneVerifyCodePlaceholder: 'Mã xác minh',
      phoneVerifyCodeSent:
        'Mã xác minh đã được gửi đến điện thoại của bạn, vui lòng kiểm tra.',
      phoneFormatError: 'Định dạng số điện thoại không hợp lệ!',
      switchToSmsLogin: 'Chuyển sang đăng nhập bằng mã SMS',
      switchToEmailLogin: 'Chuyển sang đăng nhập bằng mật khẩu email',
      getVerifyCode: 'Lấy mã',
      phoneCodeSentRetry: 'Mã xác minh đã được gửi, vui lòng thử lại sau',
      phoneCodeSendFailed: 'Gửi mã xác minh thất bại, vui lòng thử lại',
      openidOtpParseFailed: 'Phân tích mã xác minh thất bại [openid_otp]',
      phoneOtpParseFailed: 'Phân tích mã xác minh thất bại [phone_otp]',
      tooManyLogins: 'Đăng nhập quá nhiều lần, vui lòng thử lại sau',
      tooManyAttemptsRetryLater:
        'Đăng nhập sai quá nhiều lần, vui lòng thử lại sau',
      wechatTempCodeExpired:
        'Mã xác minh tạm thời của người dùng WeChat Official Account đã hết hạn',
      wechatNotBound:
        'Người dùng WeChat Official Account chưa được liên kết, vui lòng liên kết trước',
      wechatUserLocked: 'Người dùng WeChat Official Account đã bị khóa',
      phoneTempCodeExpired: 'Mã xác minh tạm thời của số điện thoại đã hết hạn',
      phoneCodeNotSent: 'Chưa gửi mã xác minh đến số điện thoại',
      phoneNotRegistered: 'Số điện thoại chưa được đăng ký',
      phoneUserLocked: 'Tài khoản số điện thoại đã bị khóa',
      emailNotRegistered: 'Email chưa được đăng ký',
      emailUserLocked: 'Tài khoản email đã bị khóa',
      passwordFormatError: 'Định dạng mật khẩu không hợp lệ',
	      emailPasswordError: 'Mật khẩu email không chính xác',
	      userNotRegistered: 'Người dùng chưa được đăng ký',
	      passwordError: 'Mật khẩu không chính xác',
	      missingLoginInfo: 'Thiếu thông tin đăng nhập',
	      welcomeLogin: 'Chào mừng đăng nhập',
	      emailCodeInvalidOrExpired:
	        'Mã xác minh email không hợp lệ hoặc đã hết hạn',
	      phoneCodeInvalidOrExpired:
	        'Mã xác minh điện thoại không hợp lệ hoặc đã hết hạn',
      bindAndRegisterSuccess: 'Liên kết + đăng ký thành công',
      welcomeRegister: 'Chào mừng đăng ký',
      rootLogin: 'Đăng nhập root',
      wechatUnbindTooMany:
        'Số lần hủy liên kết WeChat quá nhiều, vui lòng thử lại sau',
      wechatBindTooMany:
        'Số lần kiểm tra liên kết WeChat quá nhiều, vui lòng thử lại sau',
      wechatOpenidOtpParamError:
        'Tham số mã xác minh openid không hợp lệ [openid_otp]',
      wechatOpenidParamError: 'Tham số openid không hợp lệ',
      wechatOpenidOtpExpired: 'Mã xác minh openid đã hết hạn [openid_otp]',
      wechatUnbound: 'Tài khoản WeChat đã được hủy liên kết',
      wechatUnbindSuccess: 'Hủy liên kết WeChat thành công',
      wechatBindTitle: 'Liên kết WeChat',
      wechatBindSubtitle: 'Vui lòng liên kết tài khoản của bạn',
      wechatMissingAuthTitle: 'Thiếu tham số ủy quyền WeChat',
      wechatMissingAuthDesc:
        'Không phát hiện tham số openid, vui lòng đảm bảo truy cập trang này từ lối vào WeChat chính xác',
      wechatCheckBind: 'Trạng thái liên kết',
      wechatUnbind: 'Hủy liên kết',
      wechatBound: 'Đã liên kết',
      wechatNotBoundShort: 'WeChat không bị ràng buộc',
      wechatBoundDesc:
        'Tài khoản WeChat này đã liên kết với tài khoản hệ thống, bạn có thể đăng nhập trực tiếp hoặc hủy liên kết',
      wechatNotBoundDesc:
        'Tài khoản WeChat này chưa liên kết với tài khoản hệ thống, vui lòng hoàn thành biểu mẫu dưới đây để liên kết',
      wechatBindFormTitle: 'Biểu mẫu liên kết tài khoản',
      wechatMissingAuth: 'Thiếu thông tin ủy quyền WeChat, vui lòng truy cập lại',
      wechatBindStatusFailed: 'Kiểm tra trạng thái liên kết thất bại',
      wechatUnbindFailed: 'Hủy liên kết thất bại',
      wechatMissingOpenid: 'Không tìm thấy tham số openid, không thể thao tác',
      wechatConfirmBind: 'Xác nhận liên kết',
      register: 'Tạo tài khoản',
      continue: 'Tiếp tục',
      title: 'Bắt đầu xây dựng trợ lý thông minh của bạn',
      description:
        'Đăng ký miễn phí để trải nghiệm công nghệ RAG hàng đầu. Tạo kho kiến thức và trợ lý AI để nâng cao doanh nghiệp của bạn.',
      review: 'Hơn 500 đánh giá',
      autoRegisterPrefix:
        'Nhập số điện thoại để xác minh đăng nhập sẽ tự động',
      autoRegisterLink: 'đăng ký thành viên',
      alreadyHaveAccountPrefix: 'Đã có tài khoản? Bây giờ',
    },
    header: {
      knowledgeBase: 'Kho kiến thức',
      chat: 'Trò chuyện',
      register: 'Đăng ký',
      signin: 'Đăng nhập',
      home: 'Trang chủ',
      setting: 'Cài đặt người dùng',
      logout: 'Đăng xuất',
      fileManager: 'Quản lý tệp',
      flow: 'Agent',
      search: 'Tìm kiếm',
    },
    knowledgeList: {
      welcome: 'Chào mừng quay lại',
      description: 'Hôm nay bạn muốn sử dụng kho kiến thức nào?',
      createKnowledgeBase: 'Tạo kho kiến thức',
      name: 'Tên',
      namePlaceholder: 'Vui lòng nhập tên',
      doc: 'Tài liệu',
      docs: 'tài liệu',
      searchKnowledgePlaceholder: 'Tìm kiếm',
      noMoreData: 'Không còn dữ liệu',
    },
    knowledgeDetails: {
      dataset: 'Tập dữ liệu',
      testing: 'Kiểm tra truy xuất',
      configuration: 'Sửa tên kho kiến thức',
      knowledgeGraph: 'Đồ thị tri thức',
      files: 'Tệp',
      name: 'Tên tệp',
      namePlaceholder: 'Vui lòng nhập tên',
      doc: 'Tài liệu',
      datasetDescription: 'Tài liệu hiện có trong kho kiến thức',
      addFile: 'Thêm tệp',
      searchFiles: 'Tìm kiếm tệp',
      localFiles: 'Tệp cục bộ',
      emptyFiles: 'Tạo tệp trống',
      webCrawl: 'Thu thập web',
      chunkNumber: 'Số đoạn',
      fileSize: 'Kích thước tệp',
      uploadDate: 'Ngày tải lên',
      chunkMethod: 'Phương thức cắt đoạn',
      enabled: 'Bật',
      disabled: 'Tắt',
      action: 'Thao tác',
      parsingStatus: 'Trạng thái phân tích',
      processBeginAt: 'Bắt đầu lúc',
      processDuration: 'Thời lượng',
      progressMsg: 'Tiến độ',
      testingDescription:
        'Vui lòng hoàn thành kiểm tra truy xuất. Nếu bạn điều chỉnh các thiết lập mặc định như trọng số độ tương tự từ khóa, hãy đảm bảo đồng bộ cấu hình trong tệp cấu hình, vì thay đổi ở đây sẽ không được lưu tự động.',
      similarityThreshold: 'Ngưỡng tương tự',
      similarityThresholdTip:
        'Sử dụng điểm tương tự hỗn hợp để đánh giá khoảng cách giữa hai đoạn văn. Nó là tổng hợp có trọng số giữa tương tự từ khóa và cosin vector. Nếu độ tương tự giữa truy vấn và chunk nhỏ hơn ngưỡng này, chunk sẽ bị lọc bỏ.',
      vectorSimilarityWeight: 'Trọng số tương tự từ khóa',
      vectorSimilarityWeightTip:
        'Đây là trọng số của tương tự từ khóa (0–1). Trọng số tương tự vector là (1.0 - trọng số tương tự từ khóa), tổng hai trọng số bằng 1.0.',
      testText: 'Văn bản kiểm tra',
      testTextPlaceholder: 'Vui lòng nhập câu hỏi của bạn!',
      testingLabel: 'Kiểm tra',
      similarity: 'Tương tự hỗn hợp',
      termSimilarity: 'Tương tự từ khóa',
      vectorSimilarity: 'Tương tự vector',
      hits: 'Số hit',
      view: 'Xem',
      filesSelected: 'Tệp đã chọn',
      upload: 'Tải lên',
      run: 'Phân tích',
      runningStatus0: 'Chưa phân tích',
      runningStatus1: 'Đang phân tích',
      runningStatus2: 'Hủy',
      runningStatus3: 'Thành công',
      runningStatus4: 'Thất bại',
      pageRanges: 'Phạm vi trang',
      pageRangesTip:
        'Phạm vi trang: xác định phạm vi trang cần phân tích. Các trang ngoài phạm vi sẽ bị bỏ qua.',
      fromPlaceholder: 'Từ',
      fromMessage: 'Thiếu trang bắt đầu',
      toPlaceholder: 'Đến',
      toMessage: 'Thiếu trang kết thúc (không bao gồm)',
      layoutRecognize: 'Trình phân tích bố cục',
      layoutRecognizeTip:
        'Sử dụng mô hình thị giác để phân tích bố cục PDF, giúp nhận diện cấu trúc tài liệu, vị trí tiêu đề, đoạn văn, hình ảnh và bảng. Nếu chọn Naive, chỉ trích xuất văn bản thuần từ PDF. Lưu ý chức năng này chỉ hỗ trợ tệp PDF.',
      taskPageSize: 'Kích thước nhóm trang',
      taskPageSizeMessage: 'Vui lòng nhập kích thước nhóm trang!',
      taskPageSizeTip:
        'Khi bật nhận diện bố cục, tệp PDF sẽ được chia thành các nhóm liên tiếp, phân tích bố cục sẽ chạy song song giữa các nhóm để tăng tốc. "Kích thước nhóm trang" quyết định kích cỡ nhóm. Nhóm càng lớn thì khả năng cắt sai ngữ cảnh giữa hai trang càng thấp.',
      addPage: 'Thêm trang',
      greaterThan: 'Giá trị hiện tại phải lớn hơn giá trị bắt đầu!',
      greaterThanPrevious: 'Giá trị hiện tại phải lớn hơn giá trị trước đó!',
      selectFiles: 'Chọn tệp',
      changeSpecificCategory: 'Thay đổi loại cụ thể',
      uploadTitle: 'Nhấp hoặc kéo tệp vào khu vực này để tải lên',
      uploadDescription:
        'Hỗ trợ tải lên đơn lẻ hoặc nhiều tệp, nghiêm cấm tải nội dung vi phạm.',
      chunk: 'Phân tích',
      bulk: 'Hàng loạt',
      cancel: 'Hủy',
      rerankModel: 'Mô hình Rerank',
      rerankPlaceholder: 'Vui lòng chọn',
      rerankTip:
        'Tùy chọn. Nếu không chọn mô hình rerank, hệ thống sẽ sử dụng truy vấn hỗn hợp mặc định (từ khóa + vector). Nếu chọn mô hình rerank, điểm tương tự vector sẽ được thay thế bằng điểm rerank. Lưu ý: rerank có thể rất tốn thời gian.',
      topK: 'Top-K',
      topKTip: 'K chunk sẽ được gửi vào mô hình rerank.',
      delimiter: 'Ký tự phân tách',
      delimiterTip:
        'Hỗ trợ nhiều ký tự làm phân tách, nhiều ký tự được bao bởi `, ví dụ: `##`; văn bản sẽ được tách bằng xuống dòng + hai dấu # + dấu chấm phẩy, sau đó ghép lại theo giới hạn số token.',
      html4excel: 'Chuyển bảng sang HTML',
      html4excelTip:
        'Sau khi bật, bảng tính sẽ được phân tích thành bảng HTML, mỗi bảng tối đa 256 dòng, quá giới hạn sẽ phân tích thành cặp khóa-giá trị.',
      autoKeywords: 'Từ khóa tự động',
      autoKeywordsTip:
        'Khi truy vấn loại "từ khóa", hệ thống sẽ trích xuất N từ khóa cho mỗi chunk để tăng điểm xếp hạng, bạn có thể xem trong danh sách chunk.',
      autoQuestions: 'Câu hỏi tự động',
      autoQuestionsTip:
        'Khi truy vấn loại "câu hỏi", hệ thống sẽ trích xuất N câu hỏi cho mỗi chunk để tăng điểm xếp hạng, bạn có thể xem trong danh sách chunk.',
      redo: 'Có xóa {{chunkNum}} chunk hiện có không?',
      setMetaData: 'Thiết lập metadata',
      pleaseInputJson: 'Vui lòng nhập JSON',
      metaData: 'Metadata',
      deleteDocumentConfirmContent:
        'Tài liệu này có liên quan đến đồ thị tri thức. Sau khi xóa, các nút và quan hệ liên quan sẽ bị xóa, nhưng đồ thị sẽ không được cập nhật ngay lập tức. Đồ thị sẽ được cập nhật trong quá trình phân tích các tài liệu mới có nhiệm vụ trích xuất đồ thị tri thức.',
      plainText: 'Naive',
      reRankModelWaring: 'Mô hình rerank rất tốn thời gian.',
    },
    knowledgeConfiguration: {
      titleDescription:
        'Cập nhật thông tin chi tiết cho kho kiến thức của bạn tại đây, đặc biệt là phương thức cắt đoạn.',
      name: 'Tên kho kiến thức',
      photo: 'Ảnh kho kiến thức',
      description: 'Mô tả',
      language: 'Ngôn ngữ tài liệu',
      languageMessage: 'Vui lòng nhập ngôn ngữ',
      languagePlaceholder: 'Vui lòng nhập ngôn ngữ',
      permissions: 'Quyền hạn',
      embeddingModel: 'Mô hình nhúng',
      chunkTokenNumber: 'Số token mỗi chunk',
      chunkTokenNumberMessage: 'Vui lòng nhập số token mỗi chunk',
      embeddingModelTip:
        'Mô hình nhúng dùng cho các chunk. Sau khi kho kiến thức đã có tệp được phân tích thì không thể thay đổi.',
      permissionsTip:
        'Nếu quyền là "Nhóm", tất cả thành viên trong nhóm đều có thể thao tác với kho kiến thức.',
      chunkTokenNumberTip:
        'Giá trị này xấp xỉ số token mỗi chunk.',
      chunkMethod: 'Phương thức cắt đoạn',
      chunkMethodTip: 'Giải thích ở bên phải.',
      upload: 'Tải lên',
      english: 'Tiếng Anh',
      chinese: 'Tiếng Trung',
      embeddingModelPlaceholder: 'Vui lòng chọn mô hình nhúng',
      chunkMethodPlaceholder: 'Vui lòng chọn phương thức cắt đoạn',
      save: 'Lưu',
      me: 'Chỉ mình tôi',
      team: 'Nhóm',
      cancel: 'Hủy',
      methodTitle: 'Giải thích phương thức cắt đoạn',
      methodExamples: 'Ví dụ',
      methodExamplesDescription:
        'Hình minh họa dưới đây giúp bạn hiểu rõ hơn.',
      dialogueExamplesTitle: 'Ví dụ hội thoại',
      methodEmpty: 'Sẽ hiển thị giải thích trực quan cho loại kho kiến thức',
    },
    message: {
      email_code_sent: 'Mã xác minh email đã được gửi',
      permissionUpdated: 'Cập nhật quyền thành công',
      registered: 'Đăng ký thành công',
      logout: 'Đăng xuất thành công',
      logged: 'Đăng nhập thành công',
      pleaseSelectChunk: 'Vui lòng chọn chunk để phân tích',
      modified: 'Cập nhật thành công',
      created: 'Tạo thành công',
      deleted: 'Xóa thành công',
      renamed: 'Đổi tên thành công',
      operated: 'Thao tác thành công',
      updated: 'Cập nhật thành công',
      uploaded: 'Tải lên thành công',
      failed: 'Thất bại',
      200: 'Máy chủ đã trả về dữ liệu thành công',
      201: 'Tạo mới hoặc sửa dữ liệu thành công',
      202: 'Yêu cầu đã được đưa vào hàng đợi xử lý nền',
      204: 'Xóa dữ liệu thành công',
      400: 'Yêu cầu không hợp lệ, máy chủ không xử lý được',
      401: 'Vui lòng đăng nhập lại',
      403: 'Bạn đã được xác thực nhưng không có quyền truy cập',
      404: 'Không tìm thấy bản ghi tương ứng, máy chủ không xử lý được',
      406: 'Định dạng yêu cầu không được chấp nhận',
      410: 'Tài nguyên đã bị xóa vĩnh viễn',
      413: 'Tổng dung lượng tệp tải lên quá lớn',
      422: 'Lỗi xác thực khi tạo đối tượng',
      500: 'Lỗi máy chủ, vui lòng kiểm tra máy chủ',
      502: 'Lỗi gateway',
      503: 'Dịch vụ không khả dụng, máy chủ đang quá tải hoặc bảo trì',
      504: 'Gateway timeout',
      requestError: 'Lỗi yêu cầu',
      networkAnomalyDescription:
        'Mạng của bạn có vấn đề, không thể kết nối đến máy chủ',
      networkAnomaly: 'Lỗi mạng',
      hint: 'Gợi ý',
      verifyCodeError: 'Mã xác minh không đúng',
      userLocked: 'Tài khoản đã bị khóa',
    },
    fileManager: {
      name: 'Tên kho kiến thức',
      uploadDate: 'Ngày tải lên',
      knowledgeBase: 'Trạng thái thuộc kho',
      size: 'Kích thước',
      action: 'Thao tác',
      addToKnowledge: 'Liên kết kho kiến thức',
      pleaseSelect: 'Vui lòng chọn',
      newFolder: 'Tạo thư mục',
      uploadFile: 'Tải tệp',
      parseOnCreation: 'Phân tích khi tạo',
      uploadTitle: 'Nhấp hoặc kéo tệp vào khu vực này để tải lên',
      uploadDescription:
        'Hỗ trợ tải lên đơn hoặc nhiều tệp, định dạng đề xuất là markdown, mỗi tệp tối đa 10MB, tối đa 128 tệp. Nghiêm cấm tải lên nội dung vi phạm.',
      file: 'Tệp',
      directory: 'Thư mục',
      local: 'Tải từ máy',
      s3: 'Tải từ S3',
      preview: 'Xem trước',
      fileError: 'Lỗi tệp',
      uploadLimit:
        'Kích thước mỗi tệp không vượt quá 10M và tổng số tệp không vượt quá 128.',
      destinationFolder: 'Thư mục đích',
    },
    chat: {
      newConversation: 'Cuộc trò chuyện mới',
      createAssistant: 'Tạo trợ lý',
      assistantSetting: 'Cài đặt trợ lý',
      promptEngine: 'Cài đặt tham số RAG',
      modelSetting: 'Cài đặt tham số LLM',
      chat: 'Trò chuyện',
      newChat: 'Tạo cuộc trò chuyện',
      send: 'Gửi',
      sendPlaceholder: 'Hãy gửi tin nhắn cho trợ lý của bạn...',
      chatConfiguration:
        'Thiết lập trợ lý chuyên môn để luôn đồng hành hỗ trợ bạn!',
      chatConfigurationDescription:
        'Thiết lập trợ lý chuyên môn để luôn đồng hành hỗ trợ bạn!',
      assistantName: 'Vui lòng đặt tên trợ lý',
      assistantNameMessage: 'Tên trợ lý là bắt buộc',
      namePlaceholder: 'Ví dụ: Trợ lý CV Jarvis',
      assistantAvatar: 'Ảnh đại diện trợ lý',
      language: 'Ngôn ngữ',
      emptyResponse: 'Câu trả lời rỗng',
      emptyResponseTip:
        'Khi không truy xuất được nội dung liên quan trong kho kiến thức, nội dung này sẽ được dùng làm câu trả lời. Nếu bạn muốn LLM tự do trả lời khi không tìm thấy nội dung, hãy để trống.',
      emptyResponseMessage:
        'Khi kho kiến thức không truy xuất được nội dung liên quan, sẽ kích hoạt câu trả lời rỗng. Do chưa chọn kho kiến thức, vui lòng xóa cấu hình "câu trả lời rỗng".',
      setAnOpener: 'Thiết lập lời chào',
      setAnOpenerInitial:
        'Xin chào! Tôi là trợ lý của bạn, tôi có thể giúp gì cho bạn?',
      setAnOpenerTip: 'Bạn muốn chào khách hàng như thế nào?',
      knowledgeBases: 'Kho kiến thức',
      knowledgeBasesMessage: 'Vui lòng chọn',
      knowledgeBasesTip: 'Chọn kho kiến thức cần liên kết.',
      system: 'Lời nhắc hệ thống',
      systemInitialValue:
        'Bạn là một trợ lý thông minh, hãy tóm tắt nội dung kho kiến thức để trả lời câu hỏi, liệt kê dữ liệu liên quan trong kho để trả lời chi tiết. Khi tất cả nội dung kho kiến thức không liên quan đến câu hỏi, câu trả lời của bạn bắt buộc phải bao gồm câu "Không tìm thấy câu trả lời bạn cần trong kho kiến thức!". Câu trả lời cần xem xét lịch sử trò chuyện.\n        Dưới đây là kho kiến thức:\n        {knowledge}\n        Trên đây là toàn bộ kho kiến thức.',
      systemMessage: 'Vui lòng nhập',
      systemTip:
        'Khi LLM trả lời, bạn có thể dùng phần này để ràng buộc vai trò, độ dài câu trả lời, ngôn ngữ trả lời, v.v.',
      topN: 'Top N',
      topNTip:
        'Không phải tất cả các chunk có điểm tương tự lớn hơn "ngưỡng tương tự" đều được đưa cho LLM. LLM chỉ nhìn thấy "Top N" chunk này.',
      variable: 'Biến',
      variableTip:
        'Nếu bạn dùng API hội thoại, các biến có thể giúp bạn áp dụng các chiến lược khác nhau khi trò chuyện với khách hàng. Các biến này được điền vào phần "lời nhắc hệ thống" trong prompt để gợi ý LLM. "knowledge" là một biến đặc biệt, được điền bằng các chunk truy xuất được. Tất cả biến trong "lời nhắc hệ thống" cần được bao trong dấu ngoặc nhọn.',
      add: 'Thêm',
      key: 'Từ khóa',
      optional: 'Tùy chọn',
      operation: 'Thao tác',
      model: 'Mô hình',
      modelTip: 'Mô hình trò chuyện ngôn ngữ lớn',
      modelMessage: 'Vui lòng chọn',
      freedom: 'Mức sáng tạo',
      improvise: 'Sáng tạo',
      precise: 'Chuẩn xác',
      balance: 'Cân bằng',
      freedomTip:
        '"Chuẩn xác" nghĩa là mô hình sẽ trả lời thận trọng và bảo thủ hơn. "Sáng tạo" nghĩa là bạn muốn mô hình tự do hơn. "Cân bằng" là sự dung hòa giữa hai chế độ.',
      temperature: 'Nhiệt độ',
      temperatureMessage: 'Vui lòng nhập nhiệt độ',
      temperatureTip:
        'Tham số này kiểm soát độ ngẫu nhiên của mô hình. Nhiệt độ thấp sẽ khiến câu trả lời chắc chắn hơn, nhiệt độ cao sẽ khiến câu trả lời đa dạng và sáng tạo hơn.',
      topP: 'Top P',
      topPMessage: 'Vui lòng nhập Top P',
      topPTip:
        'Còn gọi là "core sampling", đặt ngưỡng để chọn một tập nhỏ từ vựng có xác suất cao để lấy mẫu, loại bỏ các từ ít khả năng xuất hiện.',
      presencePenalty: 'Phạt hiện diện',
      presencePenaltyMessage: 'Vui lòng nhập giá trị phạt hiện diện',
      presencePenaltyTip:
        'Giảm khả năng mô hình lặp lại các từ đã xuất hiện trong hội thoại bằng cách phạt các từ đó.',
      frequencyPenalty: 'Phạt tần suất',
      frequencyPenaltyMessage: 'Vui lòng nhập giá trị phạt tần suất',
      frequencyPenaltyTip:
        'Tương tự phạt hiện diện, nhưng tập trung giảm tần suất lặp lại các từ giống nhau.',
      maxTokens: 'Số token tối đa',
      maxTokensMessage: 'Vui lòng nhập số token tối đa',
      maxTokensTip:
        'Giới hạn độ dài đầu ra của mô hình, hãy thiết lập theo giới hạn của mô hình hiện tại.',
      maxTokensInvalidMessage: 'Vui lòng nhập số token hợp lệ.',
      maxTokensMinMessage: 'Số token tối đa không thể nhỏ hơn 0.',
      quote: 'Hiển thị trích dẫn',
      quoteTip: 'Có hiển thị nguồn gốc đoạn văn hay không?',
      selfRag: 'Self-RAG',
      selfRagTip: 'Tham khảo: https://huggingface.co/papers/2310.11511',
      overview: 'ID cuộc trò chuyện',
      pv: 'Số tin nhắn',
      uv: 'Số người dùng hoạt động',
      speed: 'Tốc độ xuất token',
      tokens: 'Số token đã dùng',
      round: 'Số vòng tương tác',
      thumbUp: 'Mức độ hài lòng',
      preview: 'Xem trước',
      embedded: 'Nhúng',
      serviceApiEndpoint: 'Endpoint dịch vụ API',
      apiKey: 'API KEY',
      apiReference: 'Tài liệu API',
      dateRange: 'Khoảng thời gian:',
      backendServiceApi: 'Máy chủ API',
      createNewKey: 'Tạo khóa mới',
      created: 'Tạo lúc',
      action: 'Thao tác',
      embedModalTitle: 'Nhúng vào website',
      comingSoon: 'Sắp ra mắt',
      fullScreenTitle: 'Nhúng toàn màn hình',
      fullScreenDescription:
        'Nhúng iframe dưới đây vào vị trí mong muốn trên website của bạn',
      partialTitle: 'Nhúng một phần',
      extensionTitle: 'Tiện ích Chrome',
      tokenError: 'Vui lòng tạo API Token trước!',
      betaError: 'Vui lòng xin API key trong cài đặt hệ thống trước.',
      searching: 'Đang tìm kiếm',
      parsing: 'Đang phân tích',
      uploading: 'Đang tải lên',
      uploadFailed: 'Tải lên thất bại',
      regenerate: 'Tạo lại',
      read: 'Đọc to nội dung',
      tts: 'Văn bản thành giọng nói',
      ttsTip:
        'Nếu muốn phát giọng nói, hãy chọn mô hình TTS (chuyển văn bản thành giọng nói) trong cài đặt trước.',
      relatedQuestion: 'Câu hỏi liên quan',
      answerTitle: 'Câu trả lời thông minh',
      multiTurn: 'Tối ưu đa lượt',
      multiTurnTip:
        'Tối ưu câu hỏi truy vấn kho kiến thức trong kịch bản hội thoại nhiều lượt. Sẽ gọi thêm LLM và tiêu tốn token bổ sung.',
      howUseId: 'Cách sử dụng ID cuộc trò chuyện?',
      description: 'Mô tả trợ lý',
      descriptionPlaceholder:
        'Ví dụ: bạn là trợ lý CV chuyên nghiệp, chỉ trả lời các câu hỏi liên quan đến CV.',
      useKnowledgeGraph: 'Sử dụng đồ thị tri thức',
      useKnowledgeGraphTip:
        'Truy xuất thực thể, quan hệ và báo cáo cộng đồng liên quan, giúp tăng khả năng suy luận đa bước và phức tạp.',
      keyword: 'Phân tích từ khóa',
      keywordTip:
        'Dùng LLM phân tích câu hỏi người dùng, trích xuất từ khóa quan trọng để nhấn mạnh trong tính toán độ liên quan.',
      reasoning: 'Tư duy sâu',
      reasoningTip:
        'Kích hoạt quy trình suy luận giống Deepseek-R1 / OpenAI o1. Tích hợp quá trình tìm kiếm tác tử vào workflow suy luận, cho phép mô hình chủ động truy xuất tri thức ngoài khi gặp thiếu thông tin.',
      tavilyApiKeyTip:
        'Nếu API key được thiết lập chính xác, hệ thống sẽ sử dụng Tavily để tìm kiếm web bổ sung cho kho kiến thức.',
      tavilyApiKeyMessage: 'Vui lòng nhập Tavily API Key',
      tavilyApiKeyHelp: 'Làm thế nào để lấy?',
      feedback: 'Phản hồi',
      feedbackPlaceholder: 'Vui lòng nhập ý kiến phản hồi của bạn',
      confirmDeleteConversation:
        'Bạn có chắc chắn muốn xóa cuộc trò chuyện này không?',
    },
    setting: {
      notActivated: 'Ngoại tuyến',
      activated: 'Trực tuyến',
      access_token: 'Trạng thái kích hoạt',
      profile: 'Thông tin người dùng',
      profileDescription:
        'Cập nhật ảnh đại diện và thông tin cá nhân của bạn tại đây.',
      maxTokens: 'Số token tối đa',
      maxTokensMessage: 'Vui lòng nhập số token tối đa',
      maxTokensTip:
        'Giới hạn độ dài đầu ra của mô hình, hãy thiết lập theo giới hạn của mô hình hiện tại.',
      maxTokensInvalidMessage: 'Vui lòng nhập số token hợp lệ.',
      maxTokensMinMessage: 'Số token tối đa không thể nhỏ hơn 0.',
      password: 'Mật khẩu',
      passwordDescription:
        'Vui lòng nhập mật khẩu hiện tại để thay đổi mật khẩu.',
      model: 'Cài đặt mô hình',
      modelDescription: 'Thiết lập tham số mô hình và API KEY tại đây.',
      team: 'Nhóm',
      system: 'Hệ thống',
      logout: 'Đăng xuất',
      username: 'Tên người dùng',
      corporate_name: 'Công ty/Tổ chức',
      phone_number: 'Số điện thoại',
      usernameMessage: 'Vui lòng nhập tên người dùng',
      photo: 'Ảnh đại diện',
      photoDescription: 'Sẽ hiển thị trên hồ sơ cá nhân của bạn.',
      colorSchema: 'Giao diện',
      colorSchemaMessage: 'Vui lòng chọn giao diện!',
      colorSchemaPlaceholder: 'Vui lòng chọn giao diện!',
      bright: 'Màu sáng',
      dark: 'Tối',
      timezone: 'Múi giờ',
      timezoneMessage: 'Vui lòng chọn múi giờ',
      timezonePlaceholder: 'Vui lòng chọn múi giờ',
      email: 'Địa chỉ email',
      emailDescription: 'Sau khi đăng ký, email sẽ không thể thay đổi.',
      currentPassword: 'Mật khẩu hiện tại',
      currentPasswordMessage: 'Vui lòng nhập mật khẩu hiện tại',
      newPassword: 'Mật khẩu mới',
      newPasswordMessage: 'Vui lòng nhập mật khẩu mới',
      newPasswordDescription: 'Mật khẩu mới phải dài hơn 8 ký tự.',
      confirmPassword: 'Xác nhận mật khẩu mới',
      confirmPasswordMessage: 'Vui lòng xác nhận mật khẩu mới',
      confirmPasswordNonMatchMessage: 'Mật khẩu mới không trùng khớp!',
      cancel: 'Hủy',
      addedModels: 'Mô hình đã thêm',
      modelsToBeAdded: 'Mô hình cần thêm',
      addTheModel: 'Thêm mô hình',
      apiKey: 'API-Key',
      apiKeyMessage:
        'Vui lòng nhập API key (nếu là mô hình tự triển khai, có thể bỏ qua).',
      apiKeyTip:
        'API key có thể lấy được sau khi đăng ký nhà cung cấp LLM tương ứng.',
      showMoreModels: 'Hiển thị mô hình đã thêm',
      baseUrl: 'Base-Url',
      baseUrlTip:
        'Nếu API key của bạn đến từ OpenAI, có thể bỏ qua. Các nhà cung cấp trung gian khác thường cung cấp base URL đi kèm API key.',
      modify: 'Sửa',
      systemModelSettings: 'Cài đặt mô hình toàn cục',
      chatModel: 'Mô hình trò chuyện',
      chatModelTip:
        'Tất cả kho kiến thức mới tạo sẽ dùng LLM trò chuyện mặc định này.',
      ttsModel: 'Mô hình TTS',
      ttsModelTip:
        'Mô hình TTS mặc định sẽ được dùng khi yêu cầu sinh giọng nói trong hội thoại.',
      embeddingModel: 'Mô hình nhúng',
      embeddingModelTip:
        'Tất cả kho kiến thức mới tạo sẽ dùng mô hình nhúng mặc định này.',
      img2txtModel: 'Mô hình Img2txt',
      img2txtModelTip:
        'Tất cả kho kiến thức mới tạo sẽ dùng mô hình đa phương thức mặc định, có thể mô tả hình ảnh hoặc video.',
      sequence2txtModel: 'Mô hình Speech2txt',
      sequence2txtModelTip:
        'Tất cả kho kiến thức mới tạo sẽ dùng mô hình ASR mặc định này để chuyển giọng nói thành văn bản.',
      rerankModel: 'Mô hình Rerank',
      rerankModelTip:
        'Mô hình rerank mặc định dùng để sắp xếp lại các chunk được truy xuất theo câu hỏi người dùng.',
      workspace: 'Không gian làm việc',
      upgrade: 'Nâng cấp',
      addLlmTitle: 'Thêm LLM',
      modelName: 'Tên mô hình',
      modelID: 'ID mô hình',
      modelUid: 'UID mô hình',
      modelType: 'Loại mô hình',
      addLlmBaseUrl: 'Base Url',
      vision: 'Hỗ trợ Vision hay không',
      modelNameMessage: 'Vui lòng nhập tên mô hình!',
      modelTypeMessage: 'Vui lòng nhập loại mô hình!',
      baseUrlNameMessage: 'Vui lòng nhập Base Url!',
      modelProvidersWarn:
        'Vui lòng thêm mô hình nhúng và LLM trong <b>Nhà cung cấp mô hình</b> trước, sau đó thiết lập trong "Cài đặt mô hình hệ thống".',
      add: 'Thêm',
      updateDate: 'Ngày cập nhật',
      role: 'Vai trò',
      invite: 'Mời',
      agree: 'Đồng ý',
      refuse: 'Từ chối',
      teamMembers: 'Thành viên nhóm',
      joinedTeams: 'Nhóm đã tham gia',
      sureDelete: 'Bạn có chắc chắn muốn xóa thành viên này không?',
      quit: 'Rời nhóm',
      sureQuit: 'Bạn có chắc chắn rời nhóm đã tham gia không?',
      pageTitle: 'Cài đặt',
      generalSetting: 'Cài đặt chung',
      nickname: 'Biệt danh người dùng',
      nicknamePlaceholder: 'Vui lòng nhập biệt danh người dùng',
      emailPlaceholder: 'Vui lòng nhập email',
      corporateNamePlaceholder: 'Vui lòng nhập tên công ty hoặc tổ chức',
      languageLabel: 'Ngôn ngữ',
      rolePlaceholder: 'Vui lòng chọn vai trò',
      roleEngineer: 'Kỹ sư',
      roleTeacher: 'Giáo viên',
      roleStudent: 'Sinh viên',
      userInfoSaveFailed: 'Lưu thông tin người dùng thất bại',
      backToChat: 'Quay lại trò chuyện',
      userListTitle: 'Danh sách người dùng',
      updateImageSizeList: 'Cập nhật danh sách kích thước hình ảnh',
      logoutAllDevices: 'Đăng xuất trên tất cả thiết bị',
      unbindAllOpenid: 'Hủy liên kết toàn bộ openid',
      syncModelsAndKnowledge: 'Đồng bộ mô hình và kho kiến thức',
      startDatePlaceholder: 'Ngày bắt đầu',
      endDatePlaceholder: 'Ngày kết thúc',
      downloadAllUserData: 'Tải về toàn bộ dữ liệu người dùng',
      onlyDownloadUserQuestion: 'Chỉ tải các câu hỏi của người dùng',
      unbindAllOpenidConfirm:
        'Bạn có chắc chắn muốn hủy liên kết openid của tất cả người dùng không? Sau khi hủy, tất cả người dùng sẽ mất quyền truy cập WeChat Official Account.',
      logoutAllDevicesConfirm:
        'Bạn có chắc chắn muốn đăng xuất tất cả người dùng đang trực tuyến không?',
      selectDateRangeError: 'Vui lòng chọn ngày bắt đầu và ngày kết thúc',
      endDateBeforeStartError:
        'Ngày kết thúc phải lớn hơn hoặc bằng ngày bắt đầu',
      searchUserPlaceholder:
        'Tìm kiếm người dùng (tên, email, số điện thoại, thời gian đăng nhập gần nhất...)',
      activityStatus: 'Trạng thái hoạt động',
      offline: 'Ngoại tuyến',
      onlineDevices: 'Thiết bị trực tuyến: {{count}}',
      lockUserTitle: 'Khóa người dùng vĩnh viễn',
      lockUserContent:
        'Bạn có chắc chắn muốn khóa vĩnh viễn người dùng này không? Nút mở khóa có thể mở khóa người dùng đã bị khóa.',
      deleteUserTitle: 'Xóa người dùng vĩnh viễn',
      deleteUserContent:
        'Bạn có chắc chắn muốn xóa vĩnh viễn người dùng này không? Thao tác này không thể hoàn tác.',
      unbindUserOpenidTitle: 'Hủy liên kết openid của người dùng',
      unbindUserOpenidContent:
        'Bạn có chắc chắn muốn hủy liên kết openid của người dùng này không?',
      deviceLogoutTitle: 'Đăng xuất thiết bị',
      deviceLogoutContent:
        'Bạn có chắc chắn muốn đăng xuất tất cả thiết bị của người dùng này không?',
      activateUserTooltip: 'Kích hoạt người dùng',
      lockUserTooltip: 'Khóa người dùng',
      deleteUserTooltip: 'Xóa người dùng (bao gồm dữ liệu hội thoại)',
      unbindOpenidTooltip: 'Hủy liên kết openid',
      deviceLogoutTooltip: 'Đăng xuất thiết bị',
      passwordChangeFailed: 'Đổi mật khẩu thất bại, vui lòng thử lại',
      modelUser: 'Mô hình / Người dùng',
    },
    footer: {
      profile: 'All rights reserved @ React',
    },
    layout: {
      file: 'tệp',
      knowledge: 'kho kiến thức',
      chat: 'trò chuyện',
    },
  },
};
